import React from 'react'
import './index.scss'
const DropDownMenu = (props) => {
  let { dropDownOptions = [], onSelect, nextSelection = '', dropStateOptions = [], DropDownName } = props

  return (
    <div className='drop-down-model-container'>

      <div className='drop-down-model-item-container'>
        {dropDownOptions && dropDownOptions.length >= 1 &&
          [{ name: 'All', key: 'All', residency: [], speciesUrl: '', value: 'All' }, ...dropDownOptions].map((item) => (
            <div
              key={item.key || item.name}
              className='drop-menu-options'
              onClick={() =>
                onSelect(
                  item.key || item.name,
                  nextSelection,
                  item,
                  {}
                )
              }
            >
              <div style={{ width: DropDownName === "huntTypes" ? "90%" : "75%" }}>
                <span className='drop-menu-text'>
                  {item.value || item.name || item.key || 'Unnamed'}
                </span>
              </div>
            </div>
          ))
        }

        {
          dropStateOptions && dropStateOptions.length >= 1 && [{ stateAbbr: 'ALL', stateName: 'All', stateIconUrl: '', activities: [] }, ...dropStateOptions].map((item) => (
            <div
              key={item.stateAbbr}
              className='drop-menu-options'
              onClick={() =>
                onSelect(item.stateName, nextSelection, item, {
                  returnActivitiesObject: item.activities,
                })
              }
            >
              <div style={{ width: '75%' }}>
                <span className='drop-menu-text'>{item.stateName}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default DropDownMenu
